import { useParams } from 'react-router-dom'

import { NotFound } from '@factorialco/deprecated-design-system'
import {
  SpendingPoliciesDetailsPageDocument,
  SpendingPoliciesRulesConfigurationDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { SpendingPolicyDetail } from 'modules/finance/components/SpendingPolicies/Detail'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SpendingPoliciesDetailsPage = () => {
  const { policyId } = useParams()
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(SpendingPoliciesDetailsPageDocument, {
    variables: {
      ids: [policyId ?? ''],
      companyId: company.id.toString(),
      featureCompanyId: company.id,
    },
    skip: !policyId,
  })

  const { data: configurationsData, loading: loadingConfigurations } = useQuery(
    SpendingPoliciesRulesConfigurationDocument,
    {
      variables: {
        spendingPolicyId: policyId ? policyId : undefined,
        companyId: company.id.toString(),
      },
      skip: !policyId,
    }
  )
  const canSeeSpendingPolicies = data?.finance?._policies?.spendingPoliciesSee?.can ?? false
  const canCreateSpendingPolicies = data?.finance?._policies?.spendingPolicyCreate?.can ?? false

  const spendingPolicy = data?.finance.spendingPoliciesConnection.edges.at(0)?.node
  const ruleConfigurations =
    configurationsData?.finance.spendingPolicyRuleConfigurationsConnection.nodes ?? []

  return (
    <ResponsivePage.Body
      authorized={canSeeSpendingPolicies}
      variant="full"
      showHeader={false}
      loading={loading || loadingConfigurations}
      error={error}
    >
      {spendingPolicy && canCreateSpendingPolicies ? (
        <SpendingPolicyDetail
          ruleConfigurations={ruleConfigurations}
          spendingPolicy={spendingPolicy}
        />
      ) : (
        <NotFound
          title={i18n.t('errors.page_not_found.title')}
          description={i18n.t('errors.page_not_found.description')}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default SpendingPoliciesDetailsPage
